import { TaskStage } from '../../../types/Task';

export interface KPIWidgetConfigItem {
  id: string;
  title: string;
  description: string;
  status: TaskStage;
  redirectPath: string;
  redirectStatus: TaskStage;
}

/**
 * KPI widgets available on the Home page.
 * Visibility is controlled purely by per-widget permissions on the client.
 */
export const KPI_WIDGETS: KPIWidgetConfigItem[] = [
  {
    id: 'kpi-internal-review',
    title: 'Internal Review',
    description: 'Tasks in internal review',
    status: TaskStage.INTERNAL_REVIEW,
    redirectPath: '/qp-tracking',
    redirectStatus: TaskStage.INTERNAL_REVIEW,
  },
  {
    id: 'kpi-active',
    title: 'Active',
    description: 'Tasks active on the go',
    status: TaskStage.ACTIVE,
    redirectPath: '/qp-tracking',
    redirectStatus: TaskStage.ACTIVE,
  },
  {
    id: 'kpi-marked-complete',
    title: 'Marked as Complete',
    description: 'Tasks marked complete, ready for review',
    status: TaskStage.ACTIVE_MARKED_AS_COMPLETE,
    redirectPath: '/qp-tracking',
    redirectStatus: TaskStage.ACTIVE_MARKED_AS_COMPLETE,
  },
];
